import { merchCopyRequestsLoader } from "./services/merchCopyRequests";
import { MerchCopyCampaign, MerchCopyTerms } from "./pages/MerchCopyCampaign";
import EditMerchCopyCampaign from "./pages/EditMerchCopyCampaign";
import { COPY_SLUG, COPY_TERMS_PATH, loadMerchCopy } from "./services/merchCopyCampaign";
import { useEffect } from "react"; // Добавено
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useLocation, // Добавено
} from "react-router-dom";

import "./App.css";
import CookieBanner from "./components/CookieBanner";

import RootLayout from "./layouts/RootLayout";

import Home from "./pages/Home";
import { carsLoader } from "./loaders/carsLoader";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import CarDetails, { carDetailsLoader } from "./pages/CarDetails";
import { usersLoader } from "./pages/OfferRequests";
import ThankYouOffer from "./pages/ThankYouOffer";
import ThankYouTestdrive from "./pages/ThankYouTestdrive";
import Login from "./pages/Login";
// import Upload from "./pages/Upload";
import OfferRequests from "./pages/OfferRequests";
import TestdriveRequests, {
  usersTestdriveLoader,
} from "./pages/TestdriveRequests";
import AdminLayout from "./layouts/AdminLayout";
import NewElectricExplorer from "./pages/NewElectricExplorer";
import RangerRaptor from "./pages/RangerRaptor";
import Bronco from "./pages/Bronco";
import Puma from "./pages/Puma";
import Testdrive from "./pages/Testdrive";
import { Stats } from "./pages/Stats";
import MachE from "./pages/MachE";
import PumaOfferRequests, {
  pumaProposalLoader,
} from "./pages/PumaOfferRequests";
import PumaGetInTouchRequests, {
  pumaGetInTouchLoader,
} from "./pages/GetInTouchPumaRequests";
import RangerRequests, { rangerLoader } from "./pages/RangerRequests";
import TestdrivePageRequests, {
  testdrivePageLoader,
} from "./pages/TestdrivePageRequests";
import MachEOfferRequests, {
  machEProposalLoader,
} from "./pages/MachEOfferRequests";
import MachEGetInTouchRequests, {
  machEGetInTouchLoader,
} from "./pages/MachEGetInTouchRequests";
import UploadCSV from "./pages/UploadCSV";
import FirebaseQueryTest from "./pages/FirebaseQueryTest";
import TransitCourier from "./pages/TransitCourier";
import TransitCourierGetInTouchRequests, {
  transitCourierGetInTouchLoader,
} from "./pages/GetInTouchTransitCourierRequests";
import TransitCourierApril2026GetInTouchRequests, {
  transitCourierApril2026GetInTouchLoader,
} from "./pages/TransitCourierApril2026GetInTouchRequests";
import TransitCourierDoubleCabInVan from "./pages/TransitCourierDoubleCabInVan";
import TransitCourierDoubleCabInVanRequests, {
  transitCourierDoubleCabInVanLoader,
} from "./pages/TransitCourierDoubleCabInVanRequests";
import Kuga from "./pages/Kuga";
import KugaGetInTouchRequests, {
  kugaGetInTouchLoader,
} from "./pages/KugaGetInTouchRequests";
import KugaOfferRequests, {
  kugaProposalLoader,
} from "./pages/KugaOfferRequests";
import PumaKuga from "./pages/Puma-Kuga";
import PumaKugaRequests, { pumaKugaLoader } from "./pages/PumaKugaRequests";
import TransitConnect from "./pages/TransitConnect";
import TransitConnectRequests, {
  transitConnectLoader,
} from "./pages/TransitConnectRequests";
import NewTransitCourier from "./pages/NewTransitCourier";

//----------------------------------------------------------------------
// TEST NAVISION
//----------------------------------------------------------------------
import TestNavision, { testNavisionLoader } from "./pages/TestNavision";
import TransitCustom from "./pages/TransitCustom";
import TransitCustomRequests, {
  transitCustomLoader,
} from "./pages/TransitCustomRequests";
import BroncoTestdriveRequests, {
  broncoTestdriveLoader,
} from "./pages/BroncoTestdriveRequests";
import Summer2024 from "./pages/Summer2024";
import Summer2024Requests, {
  summer2024Loader,
} from "./pages/Summer2024Requests";
import Hotlist from "./pages/Hotlist";
import MustangTestDrive from "./pages/MustangTestDrive";
import MustangTestdriveRequests, {
  MustangTestdriveLoader,
} from "./pages/MustangTestdriveRequests";
import CreateLandingPage from "./pages/CreateLandingPage";
import DynamicPage from "./pages/DynamicPage";
import LandingPageList from "./pages/Landingpages";
import EditLandingPage from "./pages/EditLandingPage";
import ImageManager from "./components/ImageManager";
import Aftersales2024 from "./pages/Aftersales2024";
import Puma2024 from "./pages/Puma2024";
import PumaFamily2026 from "./pages/PumaFamily2026";
import PumaFamily2026Requests, { pumaFamily2026RequestsLoader } from "./pages/PumaFamily2026Requests";
import Puma2024GetInTouchRequests, {
  puma2024GetInTouchLoader,
} from "./pages/Puma2024requests";
import ElectricExplorerFreeCharging from "./pages/ElectricExplorerFreeCharging";
import ElectricExplorer2024GetInTouchRequests, {
  electricExplorer2024GetInTouchLoader,
} from "./pages/ElectricExplorer2024Requests";
import Courier30990Requests, {
  Courier30990Loader,
} from "./pages/Courier30990Requests";
import Kuga52990Requests, {
  Kuga52990RequestsLoader,
} from "./pages/Kuga52990requests";
import Kuga4990campaign from "./pages/Kuga4990campaign";
import HomeRedesign from "./pages/HomeRedesign";
import RedesignLayout from "./layouts/RedesignLayout";
import ExpiredPromotion from "./pages/ExpiredPromotion";
import PumaGenE from "./pages/PumaGenE";
import PumaGenERequests, {
  pumaGenERequestsLoader,
} from "./pages/PumaGenERequests";
import FocusPromoRequests, {
  focusPromoRequestsLoader,
} from "./pages/FocusPromoRequests";
import FordProRequests, {
  fordProRequestsLoader,
} from "./pages/FordProRequests";
import RoadshowEV from "./pages/RoadshowEV";
import CapriLayout from "./layouts/CapriLayout";
import HomeCapri from "./pages/HomeCapri";
import Capri2025Requests, {
  capri2025RequestsLoader,
} from "./pages/Capri2025Requests";
import RoadshowEVRequests, {
  roadshowEVRequestsLoader,
} from "./pages/RoadshowEVRequests";
import GoElectric2025 from "./pages/GoElectric2025";
import FullWidthLayout from "./layouts/FullWidthlayout";
import GoElectricRequests, {
  goElectricRequestsLoader,
} from "./pages/GoElectricRequests";
// import TransitECourier from "./pages/TransitECourier";
import SixtyYearsTransit from "./pages/SixtyYearsTransit";
import PumaTestdriveOctNov from "./components/PumaTestdriveOctNov";
import SixtyYearsTransitRequests, {
  sixtyYearsTransitRequestsLoader,
} from "./pages/SixtyYearsTransitRequests";
import TransitECourierRequests, {
  transitECourierRequestsLoader,
} from "./pages/TransitECourierRequests";
import PumaTestdriveOctNovPage from "./pages/PumaTestdriveOctNov";
// import ThankYouTransitECourier from "./pages/ThankYouTransitECourier";
// import KugaFullHybrid from "./pages/KugaFullHybrid";
import KugaFullHybridRequests, {
  kugaFullHybridRequestsLoader,
} from "./pages/KugaFullHybridRequests";
import Puma2025GetInTouchRequests, {
  puma2025GetInTouchLoader,
} from "./pages/Puma2025requests";
import GameTermsAndConditions from "./pages/GameTermsAndConditions";
import PumaGenEWeekend from "./pages/PumaGenEWeekend";
import PumaTermsAndConditions from "./pages/PumaTermsAndConditions";
import KugaFullHybrid from "./pages/KugaFullHybrid";
import KugaJune2026 from "./pages/KugaJune2026";
import KugaJune2026Requests, {
  kugaJune2026RequestsLoader,
} from "./pages/KugaJune2026Requests";
import KugaAugust2026 from "./pages/KugaAugust2026";
import KugaAugust2026Requests, {
  kugaAugust2026RequestsLoader,
} from "./pages/KugaAugust2026Requests";
import {
  KugaFullHybrid2026RequestsLoader,
} from "./pages/KugaFullHybridRequests-2026";
import KugaFullHybrid2026Requests from "./pages/KugaFullHybridRequests-2026";
import Puma2026AprilCampaignRequests, {
  puma2026AprilCampaignLoader,
} from "./pages/Puma2026AprilCampaignRequests";
import PlevenOpen from "./pages/PlevenOpen";
import PlevenOpenRequests, {
  plevenOpenRequestsLoader,
} from "./pages/PlevenOpenRequests";
import FordEventGame from "./pages/FordEventGame";
import FordEventGameMerch from "./pages/FordEventGameMerch";
import FordEventGameMerchTerms from "./pages/FordEventGameMerchTerms";
import TheKaiserTerms from "./pages/TheKaiserTerms.jsx";
import FordEventGameRequests, {
  fordEventGameRequestsLoader,
} from "./pages/FordEventGameRequests";
import FordEventGameTerms from "./pages/FordEventGameTerms";
import FordEventGameSeptemberRequests, {
  fordEventGameSeptemberRequestsLoader,
} from "./pages/FordEventGameSeptemberRequests";
import RangerQ32026 from "./pages/RangerQ32026";
import RangerQ32026Requests, {
  rangerQ32026RequestsLoader,
} from "./pages/RangerQ32026Requests";
//----------------------------------------------------------------------

// КОМПОНЕНТ ЗА АНАЛИТИКА
function AnalyticsWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Google Ads PageView
    if (window.gtag) {
      window.gtag("config", "AW-17814485194", {
        page_path: location.pathname + location.search,
      });
    }

    // Meta Pixel PageView
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location]);

  return children;
}

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path="/"
          element={
            <AnalyticsWrapper>
              <RootLayout />
            </AnalyticsWrapper>
          }
          errorElement={<NotFound />}
        >
          <Route index element={<Home />} loader={carsLoader} />
          <Route
            path="test-navision"
            element={<TestNavision />}
            loader={testNavisionLoader}
          />
          <Route path="terms" element={<Terms />} />
          <Route path="the-kaiser-terms-and-conditions" element={<TheKaiserTerms />} />
          <Route
            path="gametermsandconditions"
            element={<GameTermsAndConditions />}
          />
          <Route
            path="pumatermsandconditions"
            element={<PumaTermsAndConditions />}
          />
          <Route
            path="fordeventgametermsandconditions"
            element={<FordEventGameTerms />}
          />
          <Route path="puma-gen-e-weekend" element={<PumaGenEWeekend />} />
          <Route path="hotlist" element={<Hotlist />} loader={carsLoader} />
          <Route path="landing/:slug" element={<DynamicPage />} />
          <Route path="landing/aftersales2024" element={<Aftersales2024 />} />
          <Route path="landing/puma2026" element={<Puma2024 />} />
          <Route path="landing/puma-family-2026" element={<PumaFamily2026 />} />
          <Route path="landing/kuga4990" element={<Kuga4990campaign />} />{" "}
          <Route
            path="landing/kuga-full-hybrid"
            element={<KugaFullHybrid />}
          />
          <Route path="landing/kuga-june-2026" element={<KugaJune2026 />} />
          <Route path="landing/kuga-august-2026" element={<KugaAugust2026 />} />
          <Route path="landing/puma-gen-e" element={<PumaGenE />} />
          <Route path="landing/roadshowev" element={<RoadshowEV />} />
          <Route path="landing/goelectric" element={<GoElectric2025 />} />
          <Route path="landing/plevenopen" element={<PlevenOpen />} />
          <Route path="landing/ford-event-game-test-drive" element={<FordEventGame />} />
          <Route path="landing/ford-event-game-merch" element={<FordEventGameMerch />} />
          <Route path="fordeventgamemerchtermsandconditions" element={<FordEventGameMerchTerms />} />
          <Route path="landing/ranger-q3-2026" element={<RangerQ32026 />} />
          <Route
            path="landing/transit-courier-double-cab-in-van"
            element={<TransitCourierDoubleCabInVan />}
          />
          <Route
            path="landing/sixty-years-transit"
            element={<SixtyYearsTransit />}
          />
          <Route
            path="landing/pumatestdrive-oct-nov"
            element={<PumaTestdriveOctNovPage />}
          />
          <Route
            path=":id"
            element={<CarDetails />}
            loader={carDetailsLoader}
          />
          <Route path={`landing/${COPY_SLUG}`} element={<MerchCopyCampaign />} loader={loadMerchCopy} />
          <Route path={COPY_TERMS_PATH.slice(1)} element={<MerchCopyTerms />} loader={loadMerchCopy} />
          <Route path="admin" element={<AdminLayout />}>
            <Route path="game-campaign" element={<EditMerchCopyCampaign />} loader={loadMerchCopy} />
            <Route path="upload" element={<UploadCSV />} />
            <Route path="createlandingpage" element={<CreateLandingPage />} />
            <Route path="images" element={<ImageManager />} />
            <Route path="edit-landing-page/:id" element={<EditLandingPage />} />
            <Route path="landingpages" element={<LandingPageList />} />
            <Route path="stats" element={<Stats />}>
              <Route path="ford-event-game-merch-new-requests" element={<FordEventGameSeptemberRequests title="Участници в новата игра Ford" filename="Ford-Merch-New.csv" showSocialProfile={false} />} loader={merchCopyRequestsLoader} />
              <Route
                path="pleven-open-requests"
                element={<PlevenOpenRequests />}
                loader={plevenOpenRequestsLoader}
              />
              <Route
                path="ford-event-game-requests"
                element={<FordEventGameRequests />}
                loader={fordEventGameRequestsLoader}
              />
              <Route
                path="ford-event-game-september-2026-requests"
                element={<FordEventGameSeptemberRequests />}
                loader={fordEventGameSeptemberRequestsLoader}
              />
              <Route
                path="kuga-full-hybrid-requests"
                element={<KugaFullHybrid2026Requests />}
                loader={KugaFullHybrid2026RequestsLoader}
              />
              <Route
                path="kuga-june-2026-requests"
                element={<KugaJune2026Requests />}
                loader={kugaJune2026RequestsLoader}
              />
              <Route
                path="kuga-august-2026-requests"
                element={<KugaAugust2026Requests />}
                loader={kugaAugust2026RequestsLoader}
              />
              <Route
                path="puma-family-2026-requests"
                element={<PumaFamily2026Requests />}
                loader={pumaFamily2026RequestsLoader}
              />
              <Route
                path="puma-2026-april-campaign-requests"
                element={<Puma2026AprilCampaignRequests />}
                loader={puma2026AprilCampaignLoader}
              />
              <Route
                path="ranger-q3-2026-requests"
                element={<RangerQ32026Requests />}
                loader={rangerQ32026RequestsLoader}
              />
              <Route
                path="kuga-full-hybrid"
                element={<KugaFullHybridRequests />}
                loader={kugaFullHybridRequestsLoader}
              />
              <Route
                path="sixty-years-transit"
                element={<SixtyYearsTransitRequests />}
                loader={sixtyYearsTransitRequestsLoader}
              />
              <Route
                path="transit-e-courier-requests"
                element={<TransitECourierRequests />}
                loader={transitECourierRequestsLoader}
              />
              <Route
                path="go-electric-requests"
                element={<GoElectricRequests />}
                loader={goElectricRequestsLoader}
              />
              <Route
                path="roadshow-ev-requests"
                element={<RoadshowEVRequests />}
                loader={roadshowEVRequestsLoader}
              />
              <Route
                path="capri-2025-requests"
                element={<Capri2025Requests />}
                loader={capri2025RequestsLoader}
              />
              <Route
                path="puma-gen-e-requests"
                element={<PumaGenERequests />}
                loader={pumaGenERequestsLoader}
              />
              <Route
                path="focus-promo-requests"
                element={<FocusPromoRequests />}
                loader={focusPromoRequestsLoader}
              />
              <Route
                path="fordpro-requests"
                element={<FordProRequests />}
                loader={fordProRequestsLoader}
              />
              <Route
                path="offer-requests"
                element={<OfferRequests />}
                loader={usersLoader}
              />
              <Route
                path="testdrive-requests"
                element={<TestdriveRequests />}
                loader={usersTestdriveLoader}
              />
              <Route
                path="Courier30990-requests"
                element={<Courier30990Requests />}
                loader={Courier30990Loader}
              />
              <Route
                path="puma-kuga-requests"
                element={<PumaKugaRequests />}
                loader={pumaKugaLoader}
              />
              <Route
                path="transit-connect-requests"
                element={<TransitConnectRequests />}
                loader={transitConnectLoader}
              />
              <Route
                path="bronco-testdrive-requests"
                element={<BroncoTestdriveRequests />}
                loader={broncoTestdriveLoader}
              />
              <Route
                path="transit-custom-requests"
                element={<TransitCustomRequests />}
                loader={transitCustomLoader}
              />
              <Route
                path="puma-offer-requests"
                element={<PumaOfferRequests />}
                loader={pumaProposalLoader}
              />
              <Route
                path="puma-getintouch-requests"
                element={<PumaGetInTouchRequests />}
                loader={pumaGetInTouchLoader}
              />
              <Route
                path="ranger-requests"
                element={<RangerRequests />}
                loader={rangerLoader}
              />
              <Route
                path="testdrive-page-requests"
                element={<TestdrivePageRequests />}
                loader={testdrivePageLoader}
              />
              <Route
                path="mach-e-offer-requests"
                element={<MachEOfferRequests />}
                loader={machEProposalLoader}
              />
              <Route
                path="mach-e-getintouch-requests"
                element={<MachEGetInTouchRequests />}
                loader={machEGetInTouchLoader}
              />
              <Route
                path="transit-courier-getintouch-requests"
                element={<TransitCourierGetInTouchRequests />}
                loader={transitCourierGetInTouchLoader}
              />
              <Route
                path="transit-courier-april-2026-getintouch-requests"
                element={<TransitCourierApril2026GetInTouchRequests />}
                loader={transitCourierApril2026GetInTouchLoader}
              />
              <Route
                path="transit-courier-double-cab-in-van-getintouch-requests"
                element={<TransitCourierDoubleCabInVanRequests />}
                loader={transitCourierDoubleCabInVanLoader}
              />
              <Route
                path="kuga-proposal-requests"
                element={<KugaOfferRequests />}
                loader={kugaProposalLoader}
              />
              <Route
                path="kuga-getintouch-requests"
                element={<KugaGetInTouchRequests />}
                loader={kugaGetInTouchLoader}
              />
              <Route
                path="summer2024-requests"
                element={<Summer2024Requests />}
                loader={summer2024Loader}
              />
              <Route
                path="mustang-testdrive-requests"
                element={<MustangTestdriveRequests />}
                loader={MustangTestdriveLoader}
              />
              <Route
                path="puma2024-requests"
                element={<Puma2024GetInTouchRequests />}
                loader={puma2024GetInTouchLoader}
              />
              <Route
                path="puma2025-requests"
                element={<Puma2025GetInTouchRequests />}
                loader={puma2025GetInTouchLoader}
              />
              <Route
                path="electric-explorer-2024-requests"
                element={<ElectricExplorer2024GetInTouchRequests />}
                loader={electricExplorer2024GetInTouchLoader}
              />
              <Route
                path="kuga52990-requests"
                element={<Kuga52990Requests />}
                loader={Kuga52990RequestsLoader}
              />
            </Route>
          </Route>
          <Route path="login" element={<Login />} />
          <Route path="testdrive" element={<Testdrive />} />
          <Route path="thank-you-offer" element={<ThankYouOffer />} />
          <Route path="thank-you-testdrive" element={<ThankYouTestdrive />} />
          <Route
            path="new-electric-explorer"
            element={<NewElectricExplorer />}
          />
          <Route path="ranger-raptor" element={<RangerRaptor />} />
          <Route path="bronco" element={<Bronco />} />
          <Route path="puma" element={<Puma />} />
          <Route path="login" element={<Login />} />
          <Route path="firebasequerytest" element={<FirebaseQueryTest />} />
          <Route path="transit-courier" element={<TransitCourier />} />
          <Route path="new-transit-courier" element={<NewTransitCourier />} />
          <Route path="transit-connect" element={<TransitConnect />} />
          <Route path="transit-custom" element={<TransitCustom />} />
          <Route path="summer-offers" element={<Summer2024 />} />
          <Route path="mustangtestdrive" element={<MustangTestDrive />} />
        </Route>
        <Route
          path="/redesign"
          element={
            <AnalyticsWrapper>
              <RedesignLayout>
                <HomeRedesign />
              </RedesignLayout>
            </AnalyticsWrapper>
          }
          loader={carsLoader}
        />
        <Route
          path="landing/capri"
          element={
            <AnalyticsWrapper>
              <CapriLayout>
                <HomeCapri />
              </CapriLayout>
            </AnalyticsWrapper>
          }
          loader={carsLoader}
        />
      </>,
    ),
  );

  return (
    <>
      <RouterProvider router={router} />
      <CookieBanner />
    </>
  );
}

export default App;
